import { Component } from '@angular/core';
import {
	Data, DataLoaderService, Subscription, ResetService, PriceCalculationService, ProgressBarService
} from '../expert-service-call.index';
@Component({
	selector: 'expert-rim-options',
	templateUrl: './expert-rim.template.html',
	styleUrls: ['./expert-rim.component.css'],
})
export class ExpertRimOptions {
	public rimOptions = [];
	public rimKeyValues: String[] = [];
	public expRim: Data[] = [];
	public selected: Data[] = [];
	public retained = [];
	public expertRimOptions: any;
	public subscription: Subscription;

	constructor(private dataLoaderService: DataLoaderService, private resetService: ResetService,
		private priceCalculationService: PriceCalculationService, private progressService: ProgressBarService) {
		this.rimOptions = this.dataLoaderService.data.rim;
	}
	ngOnInit() {
		if(this.rimOptions.length == 0 ){
			this.dataLoaderService.flagDictionary.noRimOptions = true;
		}
		//Retention Service
		this.subscription = this.priceCalculationService.notifyObservableNormalComp$.subscribe((selectedOption) => {
			if (selectedOption.fromComponent == "normalRim") {
				if (selectedOption.data[0] != undefined) {
					this.selected = selectedOption.data[0].code;
					if(!this.dataLoaderService.flagDictionary.undoActivatedForRim){
						this.dataLoaderService.previousRimExp = selectedOption.data[0].code;
					}
				} else {
					if (selectedOption.data != undefined) {
						let temp = [];
						temp.push(selectedOption.data);
						this.selected = temp[0].code;
						if(!this.dataLoaderService.flagDictionary.undoActivatedForRim){
							this.dataLoaderService.previousRimExp = temp[0].code;
						}
					} else {
						this.selected = [];
						if(!this.dataLoaderService.flagDictionary.undoActivatedForRim){
							this.dataLoaderService.previousRimExp = [];
						}
					}
				}
				this.progressService.progressBarValidation();
			}
		});

		// for undo alternative option
		
		this.priceCalculationService.notifyObservableExpertCompLastItem$.subscribe((selectedOption) => {
			if (selectedOption.fromComponent == "expertRim") {
				if (selectedOption.data[0] != undefined) {
					this.selected = selectedOption.data[0].code;
					this.dataLoaderService.previousRimExp = selectedOption.data[0].code;
				} else {
					this.selected = [];
					this.dataLoaderService.previousRimExp = [];
				}
				
				this.dataLoaderService.flagDictionary.undoActivatedForRim= false;
				this.dataLoaderService.flagDictionary.undoActivated= false;
				
				this.progressService.progressBarValidation();
				
			}
		});
		// Undo - End
		//On load	
		let rim;
		this.rimOptions.forEach(element => {
			if (element.selected === true) {
				rim = element;
				this.dataLoaderService.previousExpertRim = rim;
				this.priceCalculationService.notifyNormalCompItem({ fromComponent: "normalRim", data: [rim] });


			}
		});
		//Reset
		this.subscription = this.resetService.notifyObservable$.subscribe((res) => {
			this.selected = this.resetService.expRimCodes;
			this.priceCalculationService.notifyExpertCompItem({ fromComponent: "expertRim", data: this.resetService.expRim });
			this.priceCalculationService.notifyNormalCompItem({ fromComponent: "normalRim", data: this.resetService.expRim });
			this.priceCalculationService.expertModePriceCalculation();

		});
	}
	ngAfterContentChecked() {
		this.rimKeyValues = [];
		for (let index = 0; index < this.rimOptions.length; index++) {
			if (this.rimOptions[index].selected === false) {
				this.rimKeyValues.push(((this.rimOptions[index].code + " - " + this.rimOptions[index].description)));
			}

		}
		for (let j = 0; j < this.rimKeyValues.length; j++) {
			if (this.selected != undefined) {
				for (let i = 0; i < this.selected.length; i++) {
					let item = this.rimKeyValues[j].substring(0, this.rimKeyValues[j].indexOf(' - '));
					let temp = this.selected[i] + "";
					if (item === temp) {
						this.rimKeyValues.splice(Number(j), 1);
					}
				}
			}
		}
	}

	clearOptions() {
		this.expertRimOptions = null;
	}
	// Set flags to activate undo 
	undoActivate(){
		// for undo operation in alternative screen -start 
		this.dataLoaderService.flagDictionary.undoActivatedForRim= true;
		this.dataLoaderService.flagDictionary.undoActivated= true;
		// for undo operation in alternative screen -end
	}
	
	// adds selected Rim	
	onRimOptionClick(item) {
		setTimeout(() => {
			this.progressService.illuminateRed();
		}, 0);

		this.undoActivate() //undo activate

		// if (this.dataLoaderService.previousExpertRim.length > 0) {
		// 	this.dataLoaderService.expertRemovedCodes.push(this.dataLoaderService.previousExpertRim[0]);
		// }
		// this.dataLoaderService.previousExpertRim = [];
		this.dataLoaderService.flagDictionary.closeFlag = false;
		let rimCode;
		rimCode = item.substr(0, 3);
		// this.dataLoaderService.expAdd.push(rimCode);
		this.selected = rimCode;
		this.dataLoaderService.flagDictionary.expertValidateFlag = true;
		this.dataLoaderService.flagDictionary.expertvalidated = false;
		for (let i in this.rimOptions) {
			if (this.rimOptions[i].code === rimCode) {
				this.expRim = this.rimOptions[i];
				// this.dataLoaderService.previousExpertRim[0] = this.rimOptions[i];
				this.rimOptions[i].selected = true;
			}
			else {
				this.rimOptions[i].selected = false;
			}
		}
		this.priceCalculationService.notifyNormalCompItem({ fromComponent: "normalRim", data: [this.expRim] });
		this.priceCalculationService.notifyExpertCompItem({ fromComponent: "expertRim", data: [this.expRim] });
		this.priceCalculationService.expertModePriceCalculation();
		this.progressService.progressBarValidation();
		
	}
	//removes selected color
	deleteSelExpRim(item) {
		this.undoActivate() //undo activate
		setTimeout(() => {
			this.progressService.illuminateRed();
		}, 0);
		this.dataLoaderService.flagDictionary.closeFlag = false;
		let rimCode;
		rimCode = item.substr(0, 3);
		this.selected = [];
		this.priceCalculationService.notifyExpertCompItem({ fromComponent: "expertRim", data: this.selected });
		this.priceCalculationService.notifyNormalCompItem({ fromComponent: "normalRim", data: this.selected });
		let selcFacForRem = [];
		for (let k in this.rimOptions) {
			if (this.rimOptions[k].selected) {
				selcFacForRem.push(this.rimOptions[k]);
			}
		}
		this.priceCalculationService.notifyExpertCompForRemoved({ fromComponent: "expertRim", data: [selcFacForRem] });
		for (let i in this.rimOptions) {
			if (this.rimOptions[i].code === rimCode) {
				// this.dataLoaderService.expertRemovedCodes.push(this.rimOptions[i]);
				this.rimOptions[i].selected = false;
				this.dataLoaderService.flagDictionary.expertValidateFlag = true;
				this.dataLoaderService.flagDictionary.expertvalidated = false;
			}
		}
		this.priceCalculationService.expertModePriceCalculation();

		this.progressService.progressBarValidation();
		
	}

}


// WEBPACK FOOTER //
// ./src/app/components/selectable-tabs/expert-screen-components/expert-rim/expert-rim.component.ts